var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "c-table",
    {
      ref: "table",
      attrs: {
        title: "LBL0001246",
        columns: _vm.grid.columns,
        gridHeight: _vm.grid.height,
        data: _vm.gridData,
        filtering: false,
        columnSetting: false,
        hideBottom: false,
        usePaging: false,
        editable: _vm.editable && !_vm.disabled,
        selection: "multiple",
        rowKey: "ramVariableGuidewordId",
      },
    },
    [
      _c(
        "template",
        { slot: "table-button" },
        [
          _c(
            "q-btn-group",
            { attrs: { outline: "" } },
            [
              _vm.editable && !_vm.disabled
                ? _c("c-btn", {
                    attrs: { showLoading: false, label: "LBLADD", icon: "add" },
                    on: { btnClicked: _vm.addCause },
                  })
                : _vm._e(),
              _vm.editable && !_vm.disabled
                ? _c("c-btn", {
                    attrs: {
                      showLoading: false,
                      label: "LBLEXCEPT",
                      icon: "remove",
                    },
                    on: { btnClicked: _vm.deleteCause },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }